<template>
  <section class="worth">
    <div class="container">
      <a-typography-title :level="1">
        先进的AI智能体
      </a-typography-title>
      <a-typography-paragraph>
        基于AI大模型、RAG、Agent等多种领先技术的智慧大脑
      </a-typography-paragraph>
      <div class="box_list">
        <div v-for="(item,index) in expand.list" ref="item" class="item" :class="[`i_${index+1}`,index+1===expand.active?'active':'']">
          <a-typography-title :level="5">
            {{ item.title }}
          </a-typography-title>
          <a-typography-paragraph>
            <!--<p v-for="v in item.text">-->
            <!--  {{ v }}-->
            <!--</p>-->
            {{ item.text }}
          </a-typography-paragraph>
        </div>
      </div>
      <!-- <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_3" @click="clickToWhiteBook()">
          免费部署
        </a-button>
      </a-space> -->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from "@interface/public";

export default {
  name: "plan_worth",
  data(): DataInterface {
    return {
      expand: {
        active: 1,
        list: [
          {
            title: "知识库支持",
            text: "支持知识库定制，通过将大量的业务相关知识录入知识库，使智能体具备业务信息理解能力。针对具体的业务场景，给出精确、全面的解答，大大加快知识的检索效率",
          },
          {
            title: "丰富的工具对接",
            text: "已成功对接各种网络数据源，除了可实时获取位置信息、地图信息、天气信息等，还可以高性能的调用搜索引擎获取互联网上的数据。支持 AI 画图、图片识别、制定旅游攻略等。大大丰富智能体的信息来源与应用范围",
          },
          {
            title: "意图识别和信息融合",
            text: "通过对AI的深刻理解，结合众多工作流，使得智能体可以完成单个语言模型无法完成的任务，精确做到意图识别、参数提取、信息融合，精确的处理各种复杂的业务逻辑",
          },
        ],
      },
    };
  },
  mounted(): void {
    this.listenMouseOver();
  },
  methods: {
    /**
     * 监听鼠标移动
     */
    listenMouseOver(): void {
      this.$refs.item.forEach((v: HTMLElement, i: number) => {
        v.addEventListener(
          "mouseover",
          () => {
            this.expand.active = i + 1;
          },
          false
        );
      });
    },

    /**
     * 点击去白皮书
     */
    clickToWhiteBook(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open("https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd");
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";

@image: "@{src_image}page/productSchedulX/";
@border: 1px solid @color_14;

.worth {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;

  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.box_list {
  overflow: hidden;
  position: relative;
  margin: @margin_mo 0 0;
  border: @border;
  .borderBox();
  .shadow(0 0 20px fade(@color_black, 5));
}

.item {
  @style: width @time, background @time;
  float: left;
  overflow: hidden;
  position: relative;
  width: 30%;
  height: 360px;
  .bg("@{image}worth_item_bg.jpg");
  background-size: cover;
  //.transition(@style);

  .loop(@i) when (@i<=3) {
    &.i_@{i} {
      border-left: if(@i>1, @border, none);
      border-right: if(@i<3, @border, none);

      h5.ant-typography::before {
        .bg("@{src_image}page/productAidigitalHuman/body_icon_@{i}.png",160px, 150px, true);
      }
    }
    .loop(@i+1);
  }
  .loop(1);

  &.active {
    width: 40%;
    background: @color_white;

    h5.ant-typography {
      .transform(translate(-50%, calc(~"-50% - 65px")));
    }

    div.ant-typography {
      opacity: 1;
      .transform(translate(-50%, -65px));
    }
  }

  h5.ant-typography {
    .center();
    z-index: 1;
    .font(center, @text_big+4px, @color_12, @text_big+4px, true);
    .transition(transform @time);
    width: 100%;

    &::before {
      content: "";
      display: block;
      margin: 0 auto @margin_mo;
    }
  }

  div.ant-typography {
    @h: 130px;
    @style: opacity @time, transform @time;
    .position(absolute, auto, auto, -65px, 50%);
    z-index: 1;
    max-width: 500px;
    width: 100%;
    height: @h;
    padding: 0 @padding;
    margin: 0 auto;
    .font(justify, @text+@line, @color_13, @text);
    opacity: 0;
    .transform(translate(-50%, 0));
    .transition(@style);

    p {
      position: relative;
      padding-left: 15px;
      margin: 0;

      &::before {
        content: "";
        display: block;
        .position(absolute, 10px, auto, auto, 0);
        width: 4px;
        height: 4px;
        background: @color_6;
        border-radius: 50%;
      }
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_lg) {
  .box_list {
    overflow: initial;
    border: none;
    .shadow(none);
  }

  .item {
    float: none;
    width: 100% !important;
    max-width: 360px;
    height: auto;
    padding: 160px 0 20px;
    margin: 20px auto 0;
    background: @color_white;
    border: @border !important;
    .shadow(0 0 20px fade(@color_black, 5));

    &:nth-child(1) {
      margin-top: 0;
    }

    .loop(@i) when (@i<=5) {
      &.i_@{i} {
        @style: 0.6px;

        h5.ant-typography::before {
          .bg("@{image}worth_icon_@{i}.png", 160px*@style, 150px*@style, true);
        }
      }
      .loop(@i+1);
    }
    .loop(1);

    h5.ant-typography {
      .position(top, 20px);
      .transform(translate(0, 0)) !important;
    }

    div.ant-typography {
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: auto;
      opacity: 1 !important;
      .transform(translate(0, 0)) !important;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .worth {
    .container {
      padding: @space_mo 0;
    }
  }

  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }

  div.ant-typography {
    .font(center, @text_big_mo+@line_mo, @color_12, @text_big_mo);
  }

  .item {
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }

    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }

  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>